import posthog from 'posthog-js'

export function usePostHog() {
  // Initialize only on client to avoid SSR errors
  if (import.meta.client) {
    const { public: publicConfig } = useRuntimeConfig()

    // Prevent duplicate init on client-side navigations
    if (!(posthog && posthog.__amraInitialized)) {
      posthog.init(
        publicConfig?.posthogKey || 'phc_YuL7vWGJtzp1PlqYcVic0ZncgLd6RversOdMWT9WSKS',
        {
          api_host: publicConfig?.posthogHost || 'https://us.i.posthog.com',
          person_profiles: 'identified_only',
        }
      )
      // mark initialized
      posthog.__amraInitialized = true
    }

    return { posthog }
  }

  // On server, return a no-op to keep SSR safe
  return { posthog: { capture: () => {} } }
}